var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "activity-stage find-the-letter"
  }, [_c('h2', {
    staticClass: "find-the-letter-instructions"
  }, [_vm._v("\n      Find and select every\n      "), _vm.activityData && _vm.currentRound.letter ? _c('span', {
    class: ("color" + (_vm.letterColor))
  }, [_vm._v(_vm._s(_vm.currentRound.letter))]) : _vm._e(), _vm._v(".\n    ")]), _c('section', {
    staticClass: "find-the-letters-container"
  }, _vm._l(_vm.words, function (word) {
    return _c('div', {
      key: word.id,
      staticClass: "letters-to-type-container"
    }, [_c('aside', [_c('figure', {
      class: ("image word-" + (word.id))
    }, [_c('img', {
      attrs: {
        "src": word.wordImage.image.src
      }
    })])]), _c('div', {
      staticClass: "letter-container"
    }, _vm._l(word.letters, function (letter, index) {
      return _c('span', {
        key: ((word.id) + "-" + index),
        staticClass: "letter",
        class: letter.classes,
        on: {
          "click": function ($event) {
            return _vm.handleLetterClick(letter);
          }
        }
      }, [_vm._v("\n            " + _vm._s(letter.letter) + "\n          ")]);
    }), 0)]);
  }), 0)]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }